const de = {
  code: "de",
  nav: { book: "Jetzt buchen", whatsapp: "WhatsApp", menu: "Menü" },
  hero: {
    eyebrow: "Teneriffa · Südküste · Tägliche Abfahrten",
    lines: ["Die besten Ausflüge auf Teneriffa,", "in einer Minute gebucht."],
    sub: "Live-Verfügbarkeit, sofortige Zahlung und Ihr QR-Voucher im Postfach, bevor Sie das Handy weglegen.",
    ctaBook: "Online buchen",
    ctaWa: "Per WhatsApp schreiben",
    trust: ["Kostenlose Stornierung", "Sofortige Bestätigung", "Voucher mit QR-Code", "Sichere Kartenzahlung"],
    scroll: "Scrollen",
  },
  marquee: ["Live-Verfügbarkeit", "Zahlung in unter einer Minute", "QR-Voucher per E-Mail", "Kostenlos stornierbar bis 24 h vorher", "Lokale Crew, kleine Gruppen", "4,9 von 2.300 Gästen"],
  trips: {
    eyebrow: "Ausflüge heute",
    title: "Drei Ausflüge. Echte Termine. Kein Warten.",
    sub: "Jeder angezeigte Termin ist wirklich frei. Auswählen, bezahlen, und Ihr Voucher ist unterwegs.",
    perPerson: "pro Person",
    duration: "Dauer",
    departs: "Abfahrt",
    included: "Inklusive",
    pickDate: "Datum wählen",
    people: "Personen",
    total: "Gesamt",
    pay: "Bezahlen",
    payNow: "Bezahlen & Voucher erhalten",
    free: "Frei",
    few: "Wenige Plätze",
    full: "Ausgebucht",
    spotsLeft: "Plätze frei",
    selectDateFirst: "Wählen Sie einen freien Termin",
    hours: "Stunden",
    meeting: "Treffpunkt",
    live: "Live-Verfügbarkeit",
    items: {
      jetski: {
        title: "Jetski-Safari",
        tagline: "Zwei Stunden entlang der Südküste auf dem eigenen Jetski, durchgehend geführt.",
        includes: ["Eigener Jetski (1–2 Fahrer)", "Zertifizierter Guide & Briefing", "Neopren, Schwimmweste & Schließfächer", "Fotos Ihrer Fahrt"],
        meeting: "Puerto Colón, Steg 3",
      },
      catamaran: {
        title: "Wal- & Delfin-Katamaran",
        tagline: "Drei Stunden Segeln mit Grindwalen, Badestopp und Mittagessen an Deck.",
        includes: ["Walsichtung garantiert", "Mittagessen, Getränke & Obst", "Bade- & Schnorchelstopp", "Hotelabholung im Süden"],
        meeting: "Hafen Los Cristianos, Tor B",
      },
      teide: {
        title: "Teide Sonnenuntergang & Sterne",
        tagline: "Fünf Stunden über den Wolken: Sonnenuntergang am Kraterrand, dann der Himmel mit Starlight-Guide.",
        includes: ["Klimatisierter Kleinbus", "Astronomie-Guide & Teleskope", "Heiße Schokolade & Decke", "Hotelabholung & Rückfahrt"],
        meeting: "Abholung von Ihrem Hotel",
      },
    },
  },
  payment: {
    title: "Sichere Zahlung",
    sub: "Zahlen Sie per Karte. Ihr Voucher mit QR-Code landet im Postfach, sobald die Zahlung durch ist.",
    name: "Vollständiger Name",
    email: "E-Mail für den Voucher",
    card: "Kartennummer",
    expiry: "Gültig bis",
    cvc: "CVC",
    pay: "Bezahlen",
    processing: "Termin wird bestätigt…",
    secure: "256-Bit-verschlüsselt · Geschützt durch 3-D Secure",
    demo: "Demo-Zahlung – es wird keine Karte belastet.",
    summary: "Bestellübersicht",
    error: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
    dateGone: "Dieser Termin ist gerade ausgebucht. Bitte wählen Sie einen anderen.",
    freeCancel: "Kostenlose Stornierung bis 24 Stunden vor Abfahrt",
  },
  voucher: {
    eyebrow: "Zahlung bestätigt",
    title: "Gebucht.",
    sent: "Ihr Voucher wurde gesendet an",
    code: "Buchungscode",
    show: "Zeigen Sie diesen QR-Code am Treffpunkt",
    date: "Datum",
    time: "Uhrzeit",
    people: "Personen",
    paid: "Bezahlt",
    meeting: "Treffpunkt",
    download: "Voucher herunterladen",
    done: "Fertig",
    bookAnother: "Weiteren Ausflug buchen",
  },
  how: {
    eyebrow: "So funktioniert's",
    title: "Drei Schritte, eine Minute.",
    steps: [
      { t: "Freien Termin wählen", d: "Der Kalender zeigt, was heute wirklich verfügbar ist. Grün heißt: Ihr Platz." },
      { t: "Per Karte zahlen", d: "Apple Pay, Google Pay oder jede Karte. Ihre Plätze sind in der Sekunde der Zahlung gesichert." },
      { t: "Voucher erhalten", d: "Ein Voucher mit QR-Code kommt sofort per E-Mail. Auf dem Handy zeigen und los." },
    ],
  },
  reviews: {
    eyebrow: "Gästebewertungen",
    title: "Was Gäste nach der Rückkehr sagen.",
    items: [
      { name: "Hannah Whitmore", place: "Manchester, UK", trip: "Jetski-Safari", text: "Beim Frühstück gebucht, um halb elf auf dem Wasser. Der Voucher kam, bevor mein Kaffee leer war. Der Guide war großartig und die Fotos sind unglaublich." },
      { name: "Lukas Brandt", place: "Hamburg, Deutschland", trip: "Wal- & Delfin-Katamaran", text: "Nach zwanzig Minuten sahen wir Grindwale. Mittagessen an Deck, Badestopp in einer ruhigen Bucht, keine Menschenmassen. Der QR-Check-in dauerte etwa drei Sekunden." },
      { name: "Chiara Moretti", place: "Mailand, Italien", trip: "Teide Sonnenuntergang & Sterne", text: "Allein der Sonnenuntergang über den Wolken war es wert, dann die Sterne. Unser Guide wusste alles. Die Abholung war auf die Minute pünktlich." },
    ],
    verified: "Verifizierte Buchung",
  },
  faq: {
    eyebrow: "FAQ",
    title: "Gut zu wissen.",
    items: [
      { q: "Was ist im Preis enthalten?", a: "Alles, was auf der Ausflugskarte steht: Ausrüstung, Guide, Versicherung sowie genannte Verpflegung oder Abholung. Keine Buchungsgebühren, keine Überraschungen am Treffpunkt." },
      { q: "Kann ich stornieren oder den Termin ändern?", a: "Ja. Bis 24 Stunden vor Abfahrt kostenlos stornieren mit voller Rückerstattung, oder die Buchung mit einer WhatsApp-Nachricht auf einen anderen freien Termin verschieben." },
      { q: "Was passiert bei schlechtem Wetter?", a: "Sicherheit geht vor. Sagt Kapitän oder Guide wetterbedingt ab, wählen Sie: neuer Termin, anderer Ausflug oder volle Rückerstattung am selben Tag. Sie bleiben nie auf den Kosten sitzen." },
      { q: "Wie nutze ich den QR-Voucher?", a: "Einfach am Treffpunkt auf dem Handy zeigen. Kein Drucken, kein Papierkram. Die Crew scannt ihn und Sie sind an Bord." },
    ],
  },
  footer: {
    tagline: "Ausflüge in kleinen Gruppen an Teneriffas Südküste, veranstaltet von Menschen, die hier leben.",
    contact: "Kontakt",
    whatsapp: "Per WhatsApp chatten",
    call: "Anrufen",
    email: "E-Mail",
    payments: "Wir akzeptieren",
    hours: "Täglich geöffnet 08:00 – 21:00",
    built: "Gestaltet und entwickelt von",
    rights: "Alle Rechte vorbehalten.",
    legal: "Lizenzierter Reiseveranstalter · Registriert in Santa Cruz de Tenerife",
  },
  mobile: { from: "Ab", book: "Jetzt buchen" },
};
export default de;
